import { styled } from 'next-yak'

import * as colors from '../../constants/colors.ts'
import * as fonts from '../../constants/fonts.js'

import { StyledAvatar } from '../Avatar.jsx'

export const Sponsor = styled.span`
  font-family: ${fonts.PRIMARY_FONT};
  font-weight: 500;
  font-size: 13px;
  display: flex;
  flex-flow: row nowrap;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  ${StyledAvatar /* sc-sel */} {
    margin-right: 5px;
  }
`

export const Description = styled.span`
  position: relative;
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  color: ${colors.PRIMARY_GREY_000};
  padding: 10px;
  z-index: 10;

  &::before {
    content: '';
    transform: skewX(-5deg);
    width: 101%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
`
